import { isProd, isTestnet } from '@bfe/by-env';
import Monitor from '@fe/monitor';

enum Environment {
  DEV = 'dev',
  SITNET = 'sitnet',
  TESTNET = 'testnet',
  MAINNET = 'mainnet',
}

const monitor = new Monitor();

// 监控，根据不同环境上传不同参数,由于各个项目都要使用，后期可优化为放到 @bfeby-env
// DEV = 'dev',
let monitorEnv = Environment.SITNET;

if (isTestnet) {
  monitorEnv = Environment.TESTNET;
} else if (isProd) {
  monitorEnv = Environment.MAINNET;
}

const Init = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof (window as any) === 'undefined') return;
  if ((window as any)?.Monitor && !(window as any)?.Monitor?.initialized) {
    monitor.init(
      {
        env: monitorEnv,
        release: '1.0.0',
        routeMode: 'history',
        traceWhiteList: ['api2.', 'x-api'],
      },
      {
        v: '2.2',
        p: 'pc-spot',
      }
    );
  }
};

export const MonitorFE = {
  init: Init,
};
